import { trigger, animate, style, group, query, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition('home => more-info, home => settings, home => ovrig-info, beslut => ovrig-info, beslut => settings, ovrig-info => settings, home => beslut, alla-arenden => arende, home => alla-arenden, arende => anstallning, home => anstallning, alla-arenden => mina-tradar, arende => mina-tradar', [
    /* order */
    /* 1 */ query(':enter, :leave', style({ position: 'fixed', left: 0, right: 0 })
      , { optional: true }),
    /* 2 */ group([  // block executes in parallel
      query(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in-out', style({ transform: 'translateY(0%)' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateY(0%)' }),
        animate('200ms ease-in-out', style({ transform: 'translateX(-100%)' }))
      ], { optional: true })
    ])
  ]),
  transition('settings => beslut, settings => ovrig-info, ovrig-info => beslut, arende => alla-arenden, anstallning => arende, alla-arenden => home, beslut => home, arende => home, anstallning => home, huvud-b2 => home, more-info => home, personal-data => home, mina-tradar => alla-arenden, mina-tradar => arende', [
    /* order */
    /* 1 */ query(':enter, :leave', style({ position: 'fixed', left: 0, right: 0 })
      , { optional: true }),
    /* 2 */ group([  // block executes in parallel
      query(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in-out', style({ transform: 'translateY(0%)' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateY(0%)' }),
        animate('200ms ease-in-out', style({ transform: 'translateX(100%)' }))
      ], { optional: true })
    ])
  ]),
  transition('* => login, * => select-instance', [
    query(':enter, :leave', style({ position: 'fixed', left: 0, right: 0 })
      , { optional: true }),
    group([  // block executes in parallel
      query(':enter', [
        style({ transform: 'translateY(-200%)' }),
        animate('200ms 300ms ease-in-out', style({ transform: 'translateY(0%)' }))
      ], { optional: true }),
      query(':leave', [
        style({ opacity: 1 }),
        animate('500ms ease-in-out', style({ opacity: 0 }))
      ], { optional: true })
    ])
  ]),
  transition('login => *, select-instance => *', [
    query(':enter, :leave', style({ position: 'fixed', left: 0, right: 0 })
      , { optional: true }),
    group([  // block executes in parallel
      query(':enter', [
        style({ opacity: 0 }),
        animate('500ms 200ms ease-in-out', style({ opacity: 1 }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateY(0)' }),
        animate('200ms ease-in-out', style({ transform: 'translateY(-200%)' }))
      ], { optional: true })
    ])
  ])
])
